import React from "react";
import "../Footer.css";

interface ReportChannelProps {
  href: string;
  text: string;
}

const ReportChannel: React.FC<ReportChannelProps> = ({ href, text }) => {
  return (
    <div className="footer-report-channel">
      <a
        href={href}
        className="footer-report-link"
      >
        {text} →
      </a>
    </div>
  );
};

export default ReportChannel;
